// Centralized image imports
import UBLong from '../img/UBLong.svg';
import UBCircle from '../img/UB_circle.svg';
import UB from '../img/UB.svg';
import hero from '../img/hero.jpg';

// Blog images
import blog1 from '../img/blog1.webp';
import blog2 from '../img/blog2.jpg';
import blog3 from '../img/blog3.webp';
import blog4 from '../img/blog4.jpg';
import blog5 from '../img/blog5.webp';
import blog6 from '../img/blog6.jpg';
import blog7 from '../img/blog7.jpg';
import blog8 from '../img/blog8.webp';

// Client logos
import DOJ from '../img/Clients/DOJ.png';
import DOD from '../img/Clients/DOD.png';
import Boeing from '../img/Clients/Boeing.png';
import Northrop from '../img/Clients/Northrop.png';
import SpiritAero from '../img/Clients/SpiritAero.png';
import Argonne from '../img/Clients/Argonne.png';
import UChicago from '../img/Clients/UChicago.png';
import UCMed from '../img/Clients/UCMed.png';
import Expression from '../img/Clients/Expression.png';
import QuayChain from '../img/Clients/QuayChain.png';

export const logos = {
  UBLong,
  UBCircle,
  UB,
  hero
};

export const blogImages = {
  blog1,
  blog2,
  blog3,
  blog4,
  blog5,
  blog6,
  blog7,
  blog8
};

export const clientLogos = {
  DOJ,
  DOD,
  Boeing,
  Northrop,
  SpiritAero,
  Argonne,
  UChicago,
  UCMed,
  Expression,
  QuayChain
};
